export const version = '0.799.1'
export const chameleonWebVersion = '9.19.4'
export const chameleonCoreVersion = '7.12.1'
